import { useQuery } from '@tanstack/react-query';
import axios from 'axios';
import { AchievementEntity } from 'src/entities/Achievement.entity';

export const path = (on: string) => `/api/v5/achievements/${on}`;
export const key = (on: string) => ['useV5AchievementQuery', on];

export const useV5AchievementQuery = (on: string | undefined | null) => useQuery({
  queryKey: key(on),

  queryFn: async () => {
    const response = await axios.get<AchievementEntity[]>(path(on));

    return response.data;
  },
  enabled: !!on,
  staleTime: Infinity
});
